
export default class GetWorkOrderFormsRequest {

    public workOrderId: string = "";
    
    public processed: boolean | null = null;
}